module.exports = __webpack_public_path__ + "img/blueimage.bc74d213.png";